import _ from 'lodash';
import type { TProduct } from '../../generated/graphql';
import type { TCuratedProduct } from './queries';

export const productCustomsFields = ['value', 'hsCode', 'quantity', 'description', 'country', 'originCriterion', 'sku', 'manufacturerNsProductId', 'manufacturerProductId', 'manufacturerProductIdType'] as const;

export const pickProductsMapDefaultValues = (products: TProduct[], extraFields: (keyof TCuratedProduct)[] = []): TCuratedProduct[] => {
  return products.map((p) => _.pick(p, [...productCustomsFields, ...extraFields]));
};
